import type { Position } from './types';

export function parseCoordinates(coordStr: string): [number, number] {
  if (!coordStr || typeof coordStr !== 'string') return [0, 0];
  const parts = coordStr.replace(/[\s,]+/g, ' ').trim().split(' ').map(Number);
  if (parts.length !== 2) return [0, 0];
  const [a, b] = parts;
  if (a === undefined || b === undefined || isNaN(a) || isNaN(b)) return [0, 0];
  return [a, b];
}

export function formatCoordinates(coords: [number, number]): string {
  return `${coords[0]} ${coords[1]}`;
}

export function parsePosition(raw: Record<string, unknown>): Position {
  const labelPos = String(raw.label_position || 'bottom').toLowerCase().trim();
  const rawType = String(raw.type || '').toLowerCase().trim();
  const type: Position['type'] =
    rawType === 'atm' || rawType === 'first_aid' || rawType === 'restroom' || rawType === 'stage'
      ? rawType
      : 'vendor';
  const nameRaw = typeof raw.name === 'string' ? raw.name.trim() : '';
  const descriptionRaw = typeof raw.description === 'string' ? raw.description.trim() : '';
  return {
    uid: crypto.randomUUID(),
    positionId: String(raw.position_id || raw.id || '').trim(),
    coordinates: parseCoordinates(String(raw.coordinates || '0 0')),
    type,
    labelPosition: ['left', 'right', 'top', 'bottom'].includes(labelPos)
      ? (labelPos as 'left' | 'right' | 'top' | 'bottom')
      : 'bottom',
    ...(nameRaw ? { name: nameRaw } : {}),
    ...(descriptionRaw ? { description: descriptionRaw } : {}),
  };
}
